import classNames from 'classnames';
import { Heading, List } from 'yoso';
import { PostCard } from '~/components/Card/PostCard/PostCard';
import { T } from '~/components/I18n';
import { Lup } from '~/components/Icon/Lup';
import document from '~/components/Icon/document.png';
import folder from '~/components/Icon/folder.png';
import styles from './ZoneParticipationGuide.module.scss';
import ongoing from './ongoing.png';

export type ZoneParticipationGuideProps = {
  className?: string;
};

export const ZoneParticipationGuide = ({ className }: ZoneParticipationGuideProps) => (
  <div className={classNames(styles.root, className)}>
    <div className={styles.header}>
      <Heading level={4} className={styles.title}>
        <T name="citizen_land_detail_guide_title" />
      </Heading>
    </div>
    <div className={styles.body}>
      <List className={styles.list}>
        <li>
          <PostCard
            image={<Lup />}
            alt="yellow on blue"
            title={<T name="citizen_land_detail_guide_banner6_title" />}
            description={<T name="citizen_land_detail_guide_banner6_desc" />}
          />
        </li>
        <li>
          <PostCard
            image={folder}
            alt="folder"
            title={<T name="citizen_land_detail_guide_banner3_title" />}
            description={<T name="citizen_land_detail_guide_banner3_desc" />}
          />
        </li>
        <li>
          <PostCard
            image={ongoing}
            alt="ongoing"
            title={<T name="citizen_land_detail_guide_banner4_title" />}
            description={<T name="citizen_land_detail_guide_banner4_desc1" />}
          />
        </li>
        <li>
          <PostCard
            image={document}
            alt="document"
            title={<T name="citizen_land_detail_guide_banner5_title" />}
            description={<T name="citizen_land_detail_guide_banner5_desc" />}
          />
        </li>
      </List>
    </div>
  </div>
);
